import { MiniBetSlipSchema } from './MiniBetSlip.styles';

export const miniBetSlipStyles: MiniBetSlipSchema = {
  wrapper: {
    bottom: ['9px', null, '0'],
    left: '0',
    position: ['fixed', null, null, 'sticky'],
    right: '0',
    zIndex: 'sticky',
  },
  slideBox: {
    bg: 'alpha.400',
    color: 'gray.700',
    mb: '-4',
    borderBottomRadius: ['md', null, 'xl'],
    pb: ['3', null, '1'],
  },
  accordionItem: {
    borderTopWidth: '0',
    _last: {
      borderBottomWidth: '0',
    },
  },
  accordionHeaderText: {
    color: 'beta.600',
    boxShadow:
      '0 1px rgba(255, 255, 255, .15), 0 1px rgba(255, 255, 255, .15) inset',
  },
  accordionButton: {
    bgGradient: 'linear(to-b, beta.200, beta.400)',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.15)',
    fontSize: 'xs',
    fontWeight: 'bold',
    gap: '1',
    p: '2',
    _hover: {
      bgGradient: 'linear(to-b, beta.200, beta.400)',
    },
  },
  accordionButtonIcon: {
    color: 'beta.600',
    fontSize: 'sm',
  },

  headerStack: {
    bg: 'alpha.900',
    borderRadius: 'base',
    bottom: '100%',
    color: 'white',
    fontSize: 'xs',
    fontWeight: 'medium',
    left: '50%',
    pos: 'absolute',
    px: '4',
    py: '2',
    mb: '2',
  },
  headerText: {
    flex: '1',
  },
  headerButton: {
    display: 'inline-flex',
    fontSize: 'xl',
    minW: '0',
  },
  accordionPanel: {
    fontSize: 'xs',
    maxH: '32',
    overflow: 'auto',
    p: '0',
  },
  selectionFlex: {
    borderColor: 'blackAlpha.300',
    gap: '2',
    py: '2',
    px: '4',
    pos: 'relative',
    _notFirst: {
      borderTopStyle: 'dotted',
      borderTopWidth: '1px',
    },
    _before: {
      border: 'inherit',
      borderColor: 'whiteAlpha.300',
      content: '""',
      h: '1px',
      left: '0',
      pos: 'absolute',
      right: '0',
      top: '0',
    },
  },
  selectionMarketName: {
    flex: '1',
    fontWeight: 'bold',
  },
  selectionPropositionName: {
    flex: ['1', null, '2', null, '3'],
  },
  footerStack: {
    bgGradient: 'linear(to-b, rgba(194, 223, 255, .1), rgba(194, 223, 255, 0))',
    borderColor: 'whiteAlpha.300',
    direction: 'row',
    fontSize: 'sm',
    fontWeight: 'semibold',
    pt: '2',
    px: '4',
    pb: ['2', null, '6'],
    pos: 'relative',
    _before: {
      bgGradient: 'linear(to-b, rgba(0, 0, 0, 0.00), #000)',
      opacity: '0.2',
      bottom: 'calc(100% + 1px)',
      content: '""',
      h: '4',
      left: '0',
      pointerEvents: 'none',
      pos: 'absolute',
      right: '0',
      transitionDuration: 'normal',
      transitionProperty: 'common',
    },
    sx: {
      '& .chakra-stack': {
        minW: '5rem',
      },
    },
  },
  footerHStack: {
    flex: '1',
  },
  legsText: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    color: 'white',
  },
  legsChunks: {
    color: 'beta.200',
    fontSize: 'md',
    fontWeight: 'black',
  },
  oddsText: {
    color: 'white',
    flex: '2',
    display: 'flex',
    flexDirection: 'column',
  },
  oddsSkeletonLoader: {
    display: 'inline-block',
    ml: '1',
    w: '8',
  },
  oddsChunks: {
    color: 'beta.200',
    fontSize: 'md',
    fontWeight: 'black',
  },
  clearButton: {
    variant: 'outline',
    fontFamily: 'Ultra',
    fontSize: ['xs', 'sm'],
    px: '1',
    fontWeight: 'normal',
    textTransform: 'capitalize',
    textShadow: '0px 1px 1px rgba(0, 0, 0, 0.30)',
  },
  addToSlipButton: {
    fontSize: ['xs', 'sm'],
    px: '1',
    textShadow: '0px 1px 1px rgba(255, 255, 255, 0.47)',
    color: 'beta.500',
    fontWeight: 'normal',
  },
  buttonsHStack: {
    gap: ['0', '2'],
  },
};
